module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('div', [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  })], 1), _vm._v(" "), _c('ProductTabs'), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', [(_vm.title) ? _c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block card-zz"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.headColumns), function(col) {
    return _c('th', {
      attrs: {
        "colspan": col.colspan
      }
    }, [_vm._v(_vm._s(col.label))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.rowsAll), function(col) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(col.offer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.lead))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.quantity))]), _vm._v(" "), _c('td', _vm._l((col.goods), function(i) {
      return _c('p', {
        staticClass: "goods"
      }, [_vm._v(_vm._s(i.title) + " -> " + _vm._s(i.quantity))])
    }))])
  })), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.computedFootColumnsAll), function(cell) {
    return _c('th', [_c('span', [_vm._v(_vm._s(cell.value))])])
  }))])], 1)]), _vm._v(" "), _vm._l((_vm.rows), function(rowsDate, indexDate) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "40px"
      }
    }, [(_vm.title) ? _c('div', {
      staticClass: "card-header"
    }, [_vm._v("\n            " + _vm._s(indexDate) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', _vm._l((_vm.headColumns), function(col) {
      return _c('th', {
        attrs: {
          "colspan": col.colspan
        }
      }, [_vm._v(_vm._s(col.label))])
    }))]), _vm._v(" "), _c('tbody', _vm._l((rowsDate), function(col) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(col.offer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.leads))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(col.quantity))]), _vm._v(" "), _c('td', _vm._l((col.goods), function(i) {
        return _c('p', {
          staticClass: "goods"
        }, [_vm._v(_vm._s(i.title) + " -> " + _vm._s(i.quantity))])
      }))])
    })), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((_vm.computedFootColumns1[indexDate]), function(cell) {
      return _c('th', [_c('span', [_vm._v(_vm._s(cell.value))])])
    }))])], 1)])
  }), _vm._v(" "), _c('br')], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f9c56b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/ProductCountry.vue
// module id = 535
// module chunks = 0